import React from "react"
import { LinkButton, useTheme } from "@mallardbay/lib-react-components"

import COPY from "~config/copy-constants"

interface Props {
    readonly isShowingMore: boolean
    readonly onToggle: () => void
}

export default function ShowMoreToggleButton({
    isShowingMore,
    onToggle,
}: Props) {
    const styles = useStyleProps()

    return (
        <LinkButton style={styles.button} onClick={onToggle}>
            {isShowingMore ? COPY.SHOW_LESS : COPY.SHOW_MORE}
        </LinkButton>
    )
}

function useStyleProps() {
    const { colors } = useTheme()

    return {
        button: {
            color: colors.text,
        },
    }
}
